import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './consents/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}dashboard` }));
